import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../hooks/useLanguage";
import { useFooterData } from "./FooterContext";

function Footer() {
  // 푸터 데이터 가져오기
  const { footerData, allianceLogoImage } = useFooterData();
  const { t } = useLanguage();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const CheckBusinessInfo = () => {
        window.open(
            'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2538701507',
            'bizCommPop',
            'width=750, height=500;'
        );
    };

  const bottomPadding = () => {
    const fixedButton = document.querySelector('.prod_button');
    return !!fixedButton;
  };

  const openLink = (event) => {
    const url = event.target.value;
    if (url) {
      window.open(url, '_blank');
    } else {
    }
  };

  return (
    <footer className="layout_footer">
      <div
        className="footer_inner inner"
        style={{ paddingBottom: bottomPadding() ? '120px' : '' , alignItems: "normal"}}
      >
        <div className="company_detail">
          <Link
            to="/"
            className="footer_logo"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/";
          }}>
            <img src={footerData?.logoImageBottom?.value} alt="footer_logo"/>
          </Link>
          <div className="info_list logo">
            {footerData?.bottomLogoText?.value}
          </div>
          <ul className="info_list info_colum">
            <li>
              <span className="mr_4">COMPANY: {footerData?.shopName?.value}</span>
              <span>CEO: {footerData?.ceo?.value}</span>
            </li>
            <li>
              PHONE: <a href="tel:1544-2338">{footerData?.csMainPhone?.value}</a>/ FAX:
              {footerData?.companyFax?.value}
            </li>
            <li>
              <span className="mr_4">BUSINESS LICENCE: [{footerData?.companyNumber?.value}]</span>
              <span className="mr_4">{footerData?.companyLicenseNumber?.value}</span>
              <button
                className="text_underline"
                style={{padding:'0'}}
                type="button"
                onClick={CheckBusinessInfo}
              >
              [{t('business_info_check')}]
              </button>
            </li>
            <li>ADDRESS: {footerData?.companyZipcode?.value} {footerData?.companyAddress_street?.value} {footerData?.companyAddressDetail?.value}</li>
            <li>
              <span className="mr_4">PERSONAL INFORMATION MANAGER: {footerData?.csManagerName?.value}</span>
              <span>E-mail:
                <a href="mailto:daypay@naver.com">
                  {footerData?.companyEmail?.value}
                </a>
              </span>
            </li>
          </ul>
          <div className="copyright_list">
            <small className="copyright">
              {footerData?.shopName?.value}
              <span dangerouslySetInnerHTML={{ __html: footerData?.copyrightNotice?.value }}></span>
            </small>
            <small className="copyright">
              {footerData?.copyrightText?.value}
            </small>
          </div>
        </div>
        <div className="company_cs">
          <div className="company_info">
            <div className="tel">
              <p>{t('representative_phone')}</p>
              <a href="tel:1544-2338">
                <i className="ic_phone"></i>
                {footerData?.csMainPhone?.value}</a>
            </div>
            <div className="operate info_list column" style={{lineHeight:'1.6'}}>
              <div dangerouslySetInnerHTML={{ __html: footerData?.csOperationHour?.value }}></div>
            </div>
          </div>
          <div className="pc">
            <div className="footer_list info_list info">
              <Link to="/about/intro">{t('about_us')}</Link>
              <Link to="/about/information">{t('usage_guide')}</Link>
              <Link to="/about/terms">{t('terms_of_service')}</Link>
              <Link className="fw-500" to="/privacyPolicy">
                {t('privacy_policy')}
              </Link>
            </div>
          </div>
        </div>
        <div className="account info_list column" style={{ justifyContent: "space-between", gap:"26px" }}>
          <div className="account column" style={{ display: "flex", gap: "6px" }}>
            <p className="deposit">{t('deposit_account_info')}</p>
            <p>
              <span>{footerData?.companyBankCode?.value}</span>
              <span> {footerData?.companyAccountNumber?.value}</span>
            </p>
            <p>{t('account_holder')}: {footerData?.companyAccountOwner?.value}</p>
          </div>
          {/* 협력업체 */}
          <div className="alliance_logo_image_container">
            <div className="alliance_logo_image_title">PARTNERSHIP</div>
            <div className="alliance_logo_grid">
              {allianceLogoImage?.map((item, index) => (
                <Link to={item.alliance_url} target="_blank" className="alliance_logo_image" key={index}>
                  <img
                    className="alliance_logo_image_item"
                    src={item.new_filepath}
                    alt="cooperationCompanyImage"
                  />
                </Link>
              ))}
            </div>
          </div>
          <div className="pc" style={{ display: isMobile ? 'none' : 'block' }}>
            <div className="family-site-area">
              <select onChange={openLink}>
                <option value="">Family Site</option>
                <option value="https://www.daypayworld.com">DAYPAY WORLD</option>
                <option value="https://www.daypay.kr">DAYPAY KOREA</option>
                <option value="https://www.daypay.jp">DAYPAY JAPAN</option>
                <option value="https://www.daypay.tw">DAYPAY TAIWAN</option>
              </select>
            </div>
          </div>
        </div>
        {/* 모바일 1280사이즈에서 보이지 않게 */}
        <div className="mo">
          <div className="footer_list info_list info">
            <Link to="/about/intro">{t('about_us')}</Link>
            <Link to="/about/information">{t('usage_guide')}</Link>
            <Link to="/about/terms">{t('terms_of_service')}</Link>
            <Link className="fw-500" to="/privacy-policy">
              {t('privacy_policy')}
            </Link>
          </div>
          {/* <div className="family-site-area" style={{ marginTop: "28px" }}>
            <select onChange={openLink}>
              <option value="">Family Site</option>
              <option value="https://www.daypayworld.com">DAYPAY WORLD</option>
                <option value="https://www.daypay.co.kr">DAYPAY KOREA</option>
                <option value="https://www.daypay.jp">DAYPAY JAPAN</option>
                <option value="https://www.daypay.tw">DAYPAY TAIWAN</option>
            </select>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
